
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[ssgParams]/cookie",
      function () {
        return require("private-next-pages/[ssgParams]/cookie/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[ssgParams]/cookie"])
      });
    }
  